module.controller('feedCtrl', ['$rootScope', '$scope', '$http', '$state', '$filter', '$location', 'Session', 'TransactionService', 'baseURI', '$stateParams', 'accountService', '$window', function ($rootScope, $scope, $http, $state, $filter, $location, Session, TransactionService, baseURI, $stateParams, accountService, $window) {
  var balanceUrl = baseURI + 'card/balance';
  var feedTitle, account, usernameParam;
  var count = 0;
  var runningBalance;

  $scope.loading = true;
  $scope.disabled = true;
  $scope.accounts = accountService.getAccounts() || [];
  $scope.openAccountSelector = false;
  $scope.akimboFeed = {
    transactions: [],
    notifications: []
  };


  $scope.flipCard = false;

  $scope.toggleFlipCard = function() {
    if($scope.flipCard === false){
      $scope.flipCard = true;
      angular.element(document.querySelectorAll("#flipCardAnimation")).addClass("flipCard");
    } else {
      $scope.flipCard = false;
      angular.element(document.querySelectorAll("#flipCardAnimation")).removeClass("flipCard");
    }
  };


  // get accounts from account service
  accountService.initializeAccounts(function(err, accounts){
    if(!err){
      $scope.accounts = accounts;
      $scope.loading = false;

      $rootScope.displayWidgets = $scope.brand.showMobileWidgetsDefault;

      // get the selected account
      $scope.account = accountService.getAccount($stateParams.username);

      // set initial running balance
      runningBalance = $scope.account.balance;

      usernameParam = '/?Username=' + $scope.account.username;

      getFeed();
    }
  });

  function getFeed (lastId){
    $scope.disabled = true;

    var url = baseURI + 'transactions/all/' + (lastId || 0) + '/' + 15 + usernameParam;

    $http.get(url, {cache: true}).then(function (resp){
      var data = resp.data;
      if(data.Data.Transactions !== null && data.Data.Transactions.length > 0) {
        // update count
        count += 15;

        // normalized feed from request
        var akimboFeed = transformFeed(data.Data.Transactions);

        // Concat the two transactions, send single array to transaction service
        var formattedTransactions = akimboFeed.transactions.concat(akimboFeed.notifications);

        var cachedTransactions = TransactionService.getAll();
        var removedDuplicates = cachedTransactions.reduce(function(result, item) {
          var duplicate = false;
          for(var i in formattedTransactions){
            if (item.Id === formattedTransactions[i].Id) {
              duplicate = true;
              break;
            }
          }
          if (!duplicate) {
            result.push(item);
          }
          return result;
        }, []);

        TransactionService.update(removedDuplicates.concat(formattedTransactions));

        $scope.feedTitle = feedTitle;
        $scope.akimboFeed.notifications = akimboFeed.notifications;
        $scope.akimboFeed.transactions = $scope.akimboFeed.transactions.concat(akimboFeed.transactions);

        $scope.disabled = false;
        $scope.loading = false;
      } else {
        $scope.disabled = false;
        $scope.loading = false;
      }
    }).catch(function(error){
      console.log('err', error);
    });
  }

  // returns object of two arrays { [notiffications], [transactions] }
  var transformFeed = function(feed){
    var akimboFeed = {};
    var notifications = [];
    var transactions = [];

    for(var f in feed){
      if(feed[f].IsNotification){
        notifications.push(feed[f]);
      } else {
        transactions.push(feed[f]);
      }
    }

    akimboFeed.notifications = formatNotifications(notifications);
    akimboFeed.transactions = formatTransactions(transactions);

    return akimboFeed;
  };

  var formatTransactions = function(transactions){

    for(var t in transactions){
      if($state.current.name == 'member.home'){
        // set index balance to current balance
        if(t === '0' && count === 15){
          transactions[t].Balance = runningBalance;
        } else if (t === '0'){
          // get last amount from feed
          var lastAmount = $scope.akimboFeed.transactions[$scope.akimboFeed.transactions.length - 1].Amount;
          runningBalance = runningBalance - lastAmount;
          transactions[t].Balance = runningBalance;
        } else {
          runningBalance = runningBalance - transactions[t - 1].Amount;
          transactions[t].Balance = runningBalance;
        }
      }
      transactions[t].FormattedDate = moment(transactions[t].Time).format('h:mma MMMM Do, YYYY');
      // If there's a note, let's swap the description and title so we have room to display the note

      if (transactions[t].Photo) {
        transactions[t].Photo = "https://app.akimbocard.com/app/user/" + transactions[t].Photo;
      }
      if(transactions[t].Note !== ''){
        transactions[t].FeedTitle = transactions[t].Description;
        transactions[t].FeedDescription = transactions[t].Note;
      } else {
        transactions[t].FeedTitle = transactions[t].Title;
        transactions[t].FeedDescription = transactions[t].Description;
      }
    }
    return transactions;
  };

  var formatNotifications = function(notifications){
    for(var n in notifications){
      switch(notifications[n].Type){
        case '130':
          notifications[n].FormattedDate = moment(notifications[n].Time).format('MMMM Do, YYYY');
          notifications[n].TransId = notifications[n].Id;
          notifications[n].FormattedTitle = notifications[n].Title;
          notifications[n].FormattedDescription = notifications[n].Description;
          break;
        case 'R2':
        case 'R1':
          notifications[n].FormattedDate = moment(notifications[n].Time).format('MMMM Do, YYYY');
          notifications[n].TransId = notifications[n].Id;
          notifications[n].FormattedTitle = notifications[n].Title;
          notifications[n].FormattedDescription = notifications[n].Description;
          break;
        default:
          notifications[n].FormattedTitle = notifications[n].Title;
          notifications[n].FormattedDescription = notifications[n].Description;
          break;
      }
    }

    return notifications;
  };

  $scope.notificationClick = function(notification) {
    if (notification.Url) {

      // The API returns an absolute non-branded URL, we need to remove the first part and use just the path
      // Ideally the API should return the ui router state where we want the notification to go to
      var filteredPath = notification.Url.replace('https://app.akimbocard.com/app/#', '');

      switch (filteredPath) {
        case '/member/profile/changepin':
          $state.go('member.home.profile/changepin.step1');
          break;
        case '/member/bank/load':
          $state.go('member.home.bank/transfer.step1', { transferType: 'load' });
          break;
        case '/member/profile/smsmanage':
          $state.go('member.home.profile/smsmanage.step1');
          break;
        default:
          if (filteredPath.indexOf('/home/virtual') > -1) {
            document.body.scrollTop = document.documentElement.scrollTop = 0;
            $scope.toggleFlipCard();
          }
          break;
      }
    } else if (notification.TransId) {
      $state.go('member.home.transaction.detail', {id: notification.TransId});
    }
  };

  $scope.loadMoreFeed = function(){
    var feed = $scope.akimboFeed.transactions;

    // check if there is transaction data
    if(feed.length > 0 && !$scope.disabled){
      var lastId = feed[feed.length - 1].Id;

      $scope.disabled = true;
      getFeed(lastId);
    }
  };

}]);
